import { connect } from 'react-redux'
import Wrapper from 'pages/legislation/Wrapper'
import {
  setLegislationWrapperEditMode,
  setLegislationWrapperAdminButton,
  setLegislationWrapperContentEditor,
  setLegislationWrapperTitleEditor,
  setLegislationActNodes
} from 'redux/actions'

const mapStateToProps = state => ({
  editMode: state.legislation.editMode,
  flavour: state.layout.flavour,
  actIdMap: state.legislation.actIdMap,
  act: state.legislation.act
})

const mapDispatchToProps = dispatch => ({
  setEditMode: editMode => dispatch(setLegislationWrapperEditMode(editMode)),
  setAdminButton: AdminButton => dispatch(setLegislationWrapperAdminButton(AdminButton)),
  setContentEditor: ContentEditor => dispatch(setLegislationWrapperContentEditor(ContentEditor)),
  setTitleEditor: TitleEditor => dispatch(setLegislationWrapperTitleEditor(TitleEditor)),
  setLegislationActNodes: actNodes => dispatch(setLegislationActNodes(actNodes))
})

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)
